import './App.css';
import Home from './components/Home';
import Auth from './components/Auth';
function App() {
  return (
    <div className="App font-Inter">
      <Auth />
    </div>
  );
}

export default App;
